import vconst from "utils/helpers/structs/vconst";
import TableEmptyRow from "components/others/TableEmptyRow";
import { ProductTitle } from 'modules/product';
import { CountBadge, OperationWarehouse, ProductOperPrice } from 'modules/warehouse';
import { useObjectCard } from "../../context/ObjectCardProvider"
import ObjectProductActions from "./ObjectProductActions";

const ProductsTableBody = ({setShowSpinnerProducts, showOperationInfo, setShowOperationInfo}) => {
    const { vObject } = useObjectCard();
 
    return (
        <tbody> 
            {vObject?.operations?.map((o,i)=>{
                return (
                    <tr className={vconst?.bgRowOperStat?.[o.operStatus]||''}
                        key={`woper-${o.ID}`}>
                        <td className="prodname">
                            <ProductTitle 
                                onClick={()=>{
                                    setShowOperationInfo(o.ID);
                                }}
                                product={{
                                    prodName       : o.prodName,
                                    vendorName     : o.vendorName
                                    }}/>
                        </td>
                        <td className="price">
                            
                            <ProductOperPrice
                                showSalePrice
                                operation={o}/>
                            <div className="d-block d-md-none mt-2">
                                <CountBadge
                                    fs={12}
                                    count={o.operCount}/>
                            </div>
                        </td> 

                        <td className="count text-truncate">
                            <CountBadge 
                                fs={14}
                                count={o.operCount}/>
                        </td>
 
                        <td className="warehouse text-truncate">
                            <OperationWarehouse
                                operation={o}/>
                        </td>
                        <td className="actions">
                            <ObjectProductActions
                                showOperationInfo={showOperationInfo}
                                setShowOperationInfo={setShowOperationInfo}
                                setShowSpinnerProducts={setShowSpinnerProducts}
                                operation={o}/>
                        </td>
                    </tr>
                )
            })}

            {vObject.operations.length === 0 && (
                <TableEmptyRow colSpan={5} />
            )}
        </tbody>
    )
}

export default ProductsTableBody;